import { TEATROS_UCAM_EVENTOS, TEATRO_HASH_XEREZ, TEATRO_HASH_ADCEUTAFC } from '@/constants/teatros';

/** Teatro que reutiliza los campos como Usuario/PIN y ve el bloque como agotado. */
const TEATRO_HASH_USUARIO_PIN = 'XSb8uxOmqRUI9fMC3Kos';

/** Texto del bloque de compra cuando el teatro no tiene uno propio. */
export const ROTULO_BLOQUE_COMPRA_POR_DEFECTO = 'Venta privada';

/**
 * Clave de traducción del rótulo del bloque de compra del listado de eventos.
 *
 * Cada teatro con rótulo propio se resuelve aquí, en un único sitio, en vez de
 * anidar condicionales por hash en la plantilla.
 *
 * @param {string|null|undefined} hash hash del teatro (`teatro.hash`)
 * @returns {string|null} clave de i18n, o null si usa el rótulo por defecto
 */
export function claveRotuloBloqueCompra(hash) {
    if (hash === TEATRO_HASH_ADCEUTAFC) return 'partidos.soy_amigo_abonado';
    if (hash === TEATRO_HASH_XEREZ) return 'partidos.comprar';
    if (TEATROS_UCAM_EVENTOS.includes(hash)) return 'partidos.invitaciones';
    if (hash === TEATRO_HASH_USUARIO_PIN) return 'partidos.agotadas';

    return null;
}
